/**
 *  Reflects whether the user is viewing the mobile or desktop web UI.
 */
export enum WebResolution {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}
